import { z } from 'zod'
import { CampaignCategory } from '~/generated/graphql'

export const categoryField = {
  category: z
    .literal(CampaignCategory.Product)
    .or(z.literal(CampaignCategory.Service))
    .or(z.literal(null))
    .superRefine((v, ctx) => {
      // null は許可しない
      if (v === null) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'キャンペーンのカテゴリを選択してください',
          path: ['category'],
        })
      }
      return z.NEVER
    })
    .transform((v) => {
      return v as typeof CampaignCategory.Product | typeof CampaignCategory.Service
    }),
}

export const reservationScheduleSchemaFields = {
  schedules: z.record(z.boolean()).nullish(),
}
